import { PIKState } from "./reducer"

export const getPiks = (state: {
  paymentInKind: PIKState
}) => state.paymentInKind.paymentInKind

export const getPiksLoader = (state: { paymentInKind: PIKState }) => 
  state.paymentInKind.isLoading 
